import module from 'colaborador/module'
import template from './template.html'

export class ColaboradorCajaAhorroPrestamosItemComponent {
  idProyecto
  idColaborador
  data
  onChange

  constructor (ColaboradorCajaAhorroPrestamo, ColaboradorCajaAhorros, $q) {
    this.ColaboradorCajaAhorroPrestamo = ColaboradorCajaAhorroPrestamo
    this.ColaboradorCajaAhorros = ColaboradorCajaAhorros
    this.$q = $q
  }

  $onInit () {
    this.data.total = this.data.totalFinanciamiento + this.data.interes
    if (this.data.activo) {

    }
  }

  abrir () {
    this.expandido = true
    this.promise = this.$q.all(
      this.ColaboradorCajaAhorros.get(this.idProyecto, this.idColaborador)
      .then(({data}) => (this.cajasAhorros = data)),
      this.ColaboradorCajaAhorroPrestamo.get(this.idProyecto, this.idColaborador, this.data.id)
      .then(({data}) => (this.informacion = data))
      .then(() => (this.informacion.total = this.informacion.totalPrestamo + this.informacion.totalInteres))
      .then(() => (this.fechaMaxima = this.informacion.amortizaciones[this.informacion.amortizaciones.length - 1].fechaFinal)),
    )
    .then(() => (this.cargado = true))
  }

  eliminar () {
    this.eliminando = true
  }

  finalizar (data) {
    if (data) {
      this.onChange({$event: {data: this.data}})
    }

    this.eliminando = false
  }

  importar () {

  }

  cerrar () {
    this.expandido = false
    this.cargado = false
    this.modificando = false
  }

  modificar () {
    this.modificando = true
  }
}

module.component('colaboradorCajaAhorroPrestamosItem', {
  controller: ColaboradorCajaAhorroPrestamosItemComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
    data: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/cajaAhorro/prestamos/item/component.js